import React, { useEffect, forwardRef } from "react";
import "../../scss/popup.scss";
import { RapButton } from "@dynata/rex-raptor";

export type props = {
  title?: string;
  description: React.ReactNode | string;
  onAccept: () => void;
  onAcceptMessage: string;
  onReject: () => void;
  onRejectMessage: string;
  onIntervalCallback?: () => void;
  intervalTime?: number;
  icon?: React.ReactNode;
};

export const Popup = React.memo(
  forwardRef(
    (
      {
        title,
        description,
        onAccept,
        onAcceptMessage,
        onReject,
        onRejectMessage,
        onIntervalCallback = () => null,
        intervalTime,
        icon,
      }: props,
      ref: React.ForwardedRef<HTMLDialogElement>,
    ) => {
      useEffect(() => {
        const intervalId = setInterval(
          () => onIntervalCallback(),
          intervalTime,
        );

        return () => clearInterval(intervalId);
      }, []);

      return (
        <dialog ref={ref}>
          <div className="popup-container">
            <div className="popup-title">
              <h2>{title}</h2>
            </div>
            {icon && (
              <div className="popup-icon">
                <span className="icon-wrapper">{icon}</span>
              </div>
            )}
            <div className="popup-description">
              <p>{description}</p>
            </div>
            <div className="popup-actions">
              <RapButton
                color="danger"
                type="secondary"
                size="small"
                onClick={onReject}
              >
                {`${onRejectMessage}`}
              </RapButton>
              <RapButton
                color="main"
                type="primary"
                size="small"
                onClick={onAccept}
              >
                {`${onAcceptMessage}`}
              </RapButton>
            </div>
          </div>
        </dialog>
      );
    },
  ),
);
